import { configureStore } from '@reduxjs/toolkit';
import reservationReducer from './reservationSlice';
import workshopReducer from './workshopSlice';
import authReducer from './authSlice';
import userReducer from './userSlice';
import dashboardReducer from './dashboardSlice';
import { baseApi } from './api/baseApi';
import { injectStore } from '../services/privateApiClient';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    reservation: reservationReducer,
    workshop: workshopReducer,
    auth: authReducer,
    user: userReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

injectStore(store);